import React from "react";
import { motion } from "framer-motion";

/**
 * Slow editorial marquee — infinite, seamless, pauses on hover.
 * items: array of strings; separator: react node between items.
 */
export default function Marquee({
  items = [],
  speed = 42,
  className = "",
  itemClassName = "",
  separator = <span className="mx-8 text-[#E87B3A]">✦</span>,
}) {
  const track = [...items, ...items]; // duplicate for seamless loop
  return (
    <div
      className={`relative overflow-hidden select-none ${className}`}
      data-testid="marquee"
    >
      <motion.div
        className="flex whitespace-nowrap will-change-transform"
        animate={{ x: ["0%", "-50%"] }}
        transition={{ duration: speed, ease: "linear", repeat: Infinity }}
      >
        {track.map((label, i) => (
          <span
            key={i}
            className={`inline-flex items-center font-display text-5xl md:text-7xl uppercase leading-none ${itemClassName}`}
          >
            {label}
            {separator}
          </span>
        ))}
      </motion.div>
    </div>
  );
}
